<template>
    <div class="preferably" >
        <div class="preferably_title" v-track:exposure :track-params="JSON.stringify({event: 113, floorName: '为您优选'})">为您优选</div>
        <div class="preferably_list" >
            <div class="preferably_item"
                v-for="it in preferably"
                :key="it.id"
                @click="onDetail(it.spuId)"
                v-track:click :track-params="JSON.stringify({event: 114, floorName: '为您优选', spuId: it.spuId, spuName: it.spuName})"
            >
                <div class="img"  >
                    <img v-lazy="$viewImageNew(it.pictureUrl, 400,400)" alt="">
                </div>
                <div class="content">
                    <div class="name">
                        {{it.spuName}}
                    </div>
                    <div class="fot">
                        <div class="saleP" v-if="$isPriceShow()"><i class="icon"></i><i>￥</i>{{ it.sellPrice }}</div>
                        <div class="saleP isPrice" v-else>会员价</div>
                        <Tags v-if="it.productTags.length" :tagsArr='it.productTags' />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Tags from '../../common/Tags'
export default {
    components: {
        Tags
    },
    methods: {
        onDetail (item) {
            this.$emit('floorClick', item)
        }
    },
    props: {
        preferably: {
            type: Array,
            default: () => {
                return []
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.preferably {
    padding: 18px 24px;
    &_title {
        font-family: PingFangSC;
        font-weight: bold;
        font-size: 34px;
        line-height: 48px;
        color: #333333;
        /* padding: 0 24px; */
        margin-bottom: 20px;
    }
    &_list {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        /* padding: 0 24px; */
    }
    &_item {
        width: 344px;
        margin-bottom: 30px;
        background: #ffffff;
        border-radius: 12px;
        position: relative;
        overflow: hidden;
        .img {
            width: 100%;
            height: 344px;
            vertical-align: bottom;
            position: relative;
            display: flex;
            background-color: #fafafa;
            img {
                align-self: center;
                justify-self: center;
                margin: 0 auto;
            }
        }
        .content {
            padding: 18px 16px 12px;
            .name {
                height: 80px;
                font-size: 28px;
                line-height: 40px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                white-space: normal;
                word-break: break-all;
                margin-bottom: 8px;
            }
            .saleP {
                width: 100%;
                height: 32px;
                font-size: 32px;
                line-height: 32px;
                margin-bottom: 4px;
                font-weight: bold;
                color: #ff571f;
                font-family: Helvetica;
                i {
                    display: inline-block;
                    font-size: 24px;
                    transform: scale(0.92);
                    transform-origin: left -130%;
                }
                &.isPrice {
                    font-size: 28px;
                }
            }
        }
    }
}
</style>